export const SuccessGradient = (props) => (
  <svg
    width={80}
    height={80}
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_16189_13042)">
      <path
        d="M37.1832 54.3715C37.1621 54.3715 37.141 54.3715 37.1188 54.3706C36.2986 54.3535 35.5208 54.0028 34.965 53.3987L19.7891 36.9173C18.6614 35.6921 18.7399 33.7846 19.965 32.657C21.1911 31.5293 23.0977 31.6087 24.2254 32.8329L37.2757 47.0068L73.4465 10.9313C74.6233 9.75541 76.5329 9.75744 77.7097 10.9364C78.8857 12.1153 78.8836 14.0248 77.7036 15.2007L39.3118 53.4921C38.7469 54.0549 37.9802 54.3715 37.1832 54.3715Z"
        fill="url(#paint0_linear_16189_13042)"
      />
      <path
        d="M40 80C17.9438 80 0 62.0553 0 40C0 17.9437 17.9438 0 40 0C41.6653 0 43.015 1.34969 43.015 3.015C43.015 4.68031 41.6653 6.03016 40 6.03016C21.2694 6.03016 6.03016 21.2694 6.03016 40C6.03016 58.7317 21.2694 73.9698 40 73.9698C58.7317 73.9698 73.9699 58.7317 73.9699 40C73.9699 38.3347 75.3195 36.985 76.9848 36.985C78.6502 36.985 79.9998 38.3347 79.9998 40C80 62.0553 62.0553 80 40 80Z"
        fill="url(#paint1_linear_16189_13042)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_16189_13042"
        x1="42.9249"
        y1="16.6432"
        x2="59.9958"
        y2="54.6534"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F12E11" />
        <stop offset={1} stopColor="#F5AA19" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_16189_13042"
        x1="32.1255"
        y1="11.8994"
        x2="68.6107"
        y2="72.3133"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F12E11" />
        <stop offset={1} stopColor="#F5AA19" />
      </linearGradient>
      <clipPath id="clip0_16189_13042">
        <rect width={80} height={80} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
